import React from 'react';
import {CgSpinner} from "react-icons/cg";

const Loading = ({label = "Caricamento", className="", ...props}) => {
    return (
        <div className={`flex flex-row gap-1 items-center justify-center ${className}`} {...props}>
            <div className="select-none">{label}</div>
            <CgSpinner className="animate-spin"/>
        </div>
    );
};

export default Loading;
